import { inject, Injectable, signal } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { environment } from '@environments/environment';
import { Banner } from '../models/assets.model';
import { RealtimeService } from './realtime.service';
import { LoggerService } from './logger.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class BannerService {
  private bannerUrl = `${environment.apiUrl}/api/banner`;

  readonly banners = signal<Banner[]>([]);

  private readonly realtimeService = inject(RealtimeService);
  private readonly logger = inject(LoggerService);
  private readonly http = inject(HttpClient);

  constructor() {
    this.realtimeService.on('BannersUpdated').subscribe({
      next: () => {
        this.initBanners();
      },
      error: (error) => this.logger.error(error),
    });
  }

  public async initBanners(): Promise<Banner[]> {
    return await this.getBanners();
  }

  private async getBanners(): Promise<Banner[]> {
    try {
      const banners: Banner[] = await lastValueFrom(this.http.get<Banner[]>(`${this.bannerUrl}/get`));

      this.banners.set(banners);
      return banners;
    } catch (error) {
      this.logger.error(`Failed to fetch banners:`, error);
      return [];
    }
  }
}
